export type TimeOfDay = 'morning' | 'day' | 'evening' | 'night'

export const TIMES_OF_DAY: readonly TimeOfDay[] = ['morning', 'day', 'evening', 'night']

export function timeOfDayFromHour(hour: number): TimeOfDay {
  if (hour >= 5 && hour < 10) return 'morning'
  if (hour >= 10 && hour < 16) return 'day'
  if (hour >= 16 && hour < 19) return 'evening'
  return 'night'
}

export function parseTimeOfDay(v: unknown): TimeOfDay | null {
  return TIMES_OF_DAY.includes(v as TimeOfDay) ? (v as TimeOfDay) : null
}
